import { AbstractControl, FormGroup } from '@angular/forms';

export class CustomValidators {
  static match(key: string) {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value && (control.root || (<FormGroup>control.root).controls))
        return (<FormGroup>control.root).controls[key].value !== control.value ? { 'match': { 'currentValue': control.value, 'requiredValue': (<FormGroup>control.root).controls[key].value, 'mustMatchField': key } } : null;
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/easy-forms/custom-validators.class.ts